import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import * as echarts from 'echarts/core';
import {
  TooltipComponent,
  TooltipComponentOption,
  LegendComponent,
  LegendComponentOption
} from 'echarts/components';
import { TitleComponent, TitleComponentOption } from 'echarts/components';
import { PieChart, PieSeriesOption, GaugeChart, GaugeSeriesOption } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { PowerBIService } from '../../services/powerBI.service';
import { UserService } from '../../services/user.service';

const config = {
  tenant: "93f33571-550f-43cf-b09f-cd331338d086",
  clientId: "cfb6ae3f-8397-4f18-865f-a48028d09695",
  postLogoutRedirectUri: window.location.origin,
  prompt: "consent",
  cacheLocation: "localStorage", // enable this for IE, as sessionStorage does not work for localhost.
};
const msalConfig = {
  auth: {
    clientId: "cfb6ae3f-8397-4f18-865f-a48028d09695",
    authority: "https://login.microsoftonline.com/93f33571-550f-43cf-b09f-cd331338d086",
  },
  cache: {
    cacheLocation: "localStorage",
  }
};

const msalRequest = {
  scopes: ["https://analysis.windows.net/powerbi/api/.default"],
};

const ssoRequest = {
  loginHint: ''
};

@Component({
  selector: 'app-voice-of-customer',
  templateUrl: './voice-of-customer.component.html',
  styleUrls: ['./voice-of-customer.component.css']
})

export class VoiceOfCustomerComponent implements OnInit {
  @Input() sAccount;
  isLoading=true;
  accountDetailsNames=['ActionPlanStatus','InterviewMonth','InterviewStatus','SurveyMonth','SurveyStatus','VocNPS','NPSGlobal','NPSGlobalTarget'];
  accountDetails=[];
  private $user: Subscription;
  user:any;
  msalInstance:any;
  retrySignInTimes = 0;
  constructor(
    private powerBIService:PowerBIService,
    private userService: UserService
    ) { }
  accessToken = ''
  ngOnInit(): void {
    this.$user = this.userService.user$.subscribe(data => {
      if (Array.isArray(data) && data.length) {
        ssoRequest.loginHint = data[0].username;

        this.msalInstance = new (window as any).Msal.UserAgentApplication(msalConfig);
        this.signIn().then(() => {
          this.getData();
        });
      }
    });
  }
  ngAfterViewInit():void{
    echarts.use([
      TooltipComponent,
      TitleComponent,
      LegendComponent,
      PieChart,
      CanvasRenderer,
      LabelLayout,
      GaugeChart
    ]);
    type EChartsOption = echarts.ComposeOption<
      TooltipComponentOption | LegendComponentOption | PieSeriesOption | TitleComponentOption
    >;
    var myNPS = echarts.init(document.getElementById('npsmain'));
    var myGartner = echarts.init(document.getElementById('gartnermain'));
    var npsoption: EChartsOption;

    npsoption = {
      title:{
        text:'NPS Gauge',
        left: "center",
        top: "center",
        zlevel: 0,
        z: 6,
        show: true,
        textStyle: {
          fontSize: 10,
          textBorderColor:'white',
          textBorderWidth:3,
          textBorderType: 'solid' 
        }
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '2%',
        left: 'right',
        orient: 'vertical',
        textStyle:{
          textBorderColor:'white',
          textBorderWidth:3,
          textBorderType: 'solid' 
        }
      },
      color:['red', 'yellow', 'green'],
      series: [
        {
          name: 'NPS Gauge',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '15',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [
            { value: 33, name: 'Detractor' },
            { value: 33, name: 'Passive' },
            { value: 33, name: 'Promoter' }
          ]
        }
      ]
    };
    var gartneroption:echarts.ComposeOption<GaugeSeriesOption> ={
          series: [
            {
              type: 'gauge',
              startAngle: 180,
              endAngle: 0,
              min: 0,
              max: 240,
              splitNumber: 4,
              itemStyle: {
                color: '#58D9F9',
                shadowColor: 'rgba(0,138,255,0.45)',
                shadowBlur: 10,
                shadowOffsetX: 2,
                shadowOffsetY: 2
              },
              progress: {
                show: true,
                roundCap: true,
                width: 18
              },
              pointer: {
                icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
                length: '75%',
                width: 16,
                offsetCenter: [0, '5%']
              },
              axisLine: {
                roundCap: true,
                lineStyle: {
                  width: 18
                }
              },
              axisTick: {
                splitNumber: 2,
                lineStyle: {
                  width: 2,
                  color: '#999'
                }
              },
              splitLine: {
                length: 1,
                lineStyle: {
                  width: 3,
                  color: '#999'
                }
              },
              axisLabel: {
                distance: 25,
                color: '#999',
                fontSize: 10
              },
              title: {
                show: false
              },
              detail: {
                backgroundColor: '#fff',
                borderColor: '#999',
                borderWidth: 0,
                width: '60%',
                lineHeight: 0,
                height: 0,
                borderRadius: 8,
                offsetCenter: [0, '35%'],
                valueAnimation: true,
                formatter: function (value) {
                  return '{value|' + value.toFixed(0) + '}{unit|km/h}';
                },
                rich: {
                  value: {
                    fontSize: 0,
                    fontWeight: 'bolder',
                    color: '#777'
                  },
                  unit: {
                    fontSize: 0,
                    color: '#999',
                    padding: [0, 0, -20, 10]
                  }
                }
              },
              data: [
                {
                  value: 100
                }
              ]
            }
          ]
        };
    myNPS.setOption(npsoption);
    myGartner.setOption(gartneroption);
  }

  signIn() {
    return new Promise((resolve: any, reject: any) => {
      if (this.msalInstance.getAccount()) {
        resolve();
      } else {
        this.msalInstance.ssoSilent(ssoRequest).then(() => {
          resolve();
        }).catch((err) => {
          console.log(err);
          if (this.retrySignInTimes < 3) {
            this.retrySignInTimes++;
            this.signIn().then(() => {
              this.retrySignInTimes = 0;
              resolve();
            }).catch(() => {
              reject();
            });
          } else {
            reject();
          }
        });
      }
    });
  }

  getData(){
    this.msalInstance.acquireTokenSilent(msalRequest).then((res) => {
      this.accessToken = res.accessToken
      let query = { "queries": [ { "query" :  "EVALUATE SUMMARIZE (NATURALLEFTOUTERJOIN(CALCULATETABLE (SELECTCOLUMNS('Dim Account',\"GlobalAccountName\", 'Dim Account'[GlobalAccountName],\"AccountSTName\", 'Dim Account'[AccountSTName],\"AccountSTID\", \"\" & 'Dim Account'[AccountSTID],\"GlobalAccountID\", 'Dim Account'[GlobalAccountID],\"ClientID\", RELATED('Dim Client'[ClientID]),\"ClientName\", RELATED('Dim Client'[ClientName]),\"ClientClass\", RELATED('Dim Client'[IsClientClass])),CONTAINSSTRING('Dim Client'[ClientID], \""+this.sAccount.code+"\"),CONTAINSSTRING('Dim Account'[AccountSTID], \""+this.sAccount.accountID+"\"),CONTAINSSTRING('Dim Account'[GlobalAccountID], \""+this.sAccount.sfdcglobalid+"\")),SELECTCOLUMNS('Dim AccountVoc',\"AccountSTID\",\"\" & 'Dim AccountVoc'[AccountSTID],\"ActionPlanStatus\", 'Dim AccountVoc'[ActionplanStatus],\"InterviewMonth\", 'Dim AccountVoc'[InterviewMonth],\"InterviewStatus\", 'Dim AccountVoc'[InterviewStatus],\"SurveyMonth\", 'Dim AccountVoc'[SurveyMonth],\"SurveyStatus\", 'Dim AccountVoc'[SurveyStatus],\"VocNPS\", 'Fact AccountVocNPS'[_NPS],\"NPSGlobal\", 'Fact NPS'[_NPS Global],\"NPSGlobalTarget\", 'Fact NPS'[_NPS Global Target])),[GlobalAccountName], [AccountSTName], [AccountSTID], [GlobalAccountID],[ClientID], [ClientName], [ClientClass],[ActionPlanStatus], [InterviewMonth], [InterviewStatus], [SurveyMonth], [SurveyStatus],[VocNPS], [NPSGlobal], [NPSGlobalTarget])"} ], "serializerSettings": { "includeNulls": true } }
      this.powerBIService.getPowBIData('3c62c911-9c32-4817-af8e-910a2c5a6ca2', query, this.accessToken).then((res)=>{
        this.isLoading = false;
        if(res['results'].length>0&&res['results'][0]['tables'].length>0&&res['results'][0]['tables'][0]['rows'].length>0){
          let d = res['results'][0]['tables'][0]['rows'][0];
          this.accountDetailsNames.forEach( n => {
            if(d.hasOwnProperty("["+n+"]")){
              let detailObj = {
                name: n,
                value: d["["+n+"]"]
              }
              this.accountDetails.push(detailObj);
            }
          });
        }
        //document.getElementById('PowerBIresult').innerHTML = this.syntaxHighlight(res);
      }, (err)=>{console.log(err)})
    }).catch((err) => {
      console.log(err);
    })
  }

  syntaxHighlight(json) {
    if (typeof json != 'string') {
      json = JSON.stringify(json, undefined, 2);
    }
    json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
    var cls = 'number';
    if (/^"/.test(match)) {
    if (/:$/.test(match)) {
    cls = 'key';
    } else {
    cls = 'string';
    }
    } else if (/true|false/.test(match)) {
    cls = 'boolean';
    } else if (/null/.test(match)) {
    cls = 'null';
    }
    return '<span class="' + cls + '">' + match + '</span>';
    });
  }

}
